import React, { useEffect, useRef, useState } from 'react';
import referralImage from '../../../assets/referral_image.png';
import referralKnowMore from '../../../assets/referral_know_more.png';
import '../../../styles/containers/components/ReferralPage.scss';
import { ReactComponent as WhatssppLogo } from '../../../assets/whatsapp.svg';
import useMoengage from '../../../hooks/useMoengage';
import { getUserBasicDetailsByMitraAppBackendUserId } from '../../../services/API/MoengageHelper';

const ReferralComponent = () => {
  const [phoneNumber, setPhoneNumber] = useState('');
  const [userPersonalNumber, setUserPersonalNumber] = useState('');
  const generateLinkRef = useRef(null);
  const knowMoreDiv = useRef(null);
  const mainDiv = useRef(null);
  const shareWhatsappLink = useRef(null);
  const [userId, setUserId] = useState('');
  const [referralLink, setReferralLink] = useState(null);
  const [errMsg, setErrorMsg] = useState(null);
  const [createMoengageUser, trackEvent] = useMoengage();

  const onInputChange = e => {
    if (e.target.value.length <= 10) {
      setPhoneNumber(e.target.value);
      if (e.target.value.length === 10) generateLinkRef.current.style.display = '';
      else generateLinkRef.current.style.display = 'none';
      if (errMsg != null) setErrorMsg(null);
    }
  };

  const shareOnWhatsapp = () => {
    shareWhatsappLink.current.click();
  };

  const generateLink = async () => {
    if (phoneNumber === userPersonalNumber) {
      setErrorMsg('You cannot enter your own number');
      return;
    }
    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_HOST}/referrals/link/${encodeURIComponent(userId)}/${encodeURIComponent(phoneNumber)}`
      );
      const data = await res.json();
      if (res.status === 200) {
        setReferralLink(data.referralLink);
        // send phoneNumber to only mongaege, thats it. no other information for this user. we just have his phoneNumber.
        trackEvent('user_referred', {
          phone: phoneNumber,
        });
      } else setErrorMsg(data.message);
    } catch (error) {
      setErrorMsg('Service Unavailable!');
    }
  };

  const showKnowMore = () => {
    knowMoreDiv.current.classList.add('know_more_show');
    mainDiv.current.classList.add('blur_background');
  };

  const hideKnowMore = () => {
    knowMoreDiv.current.classList.remove('know_more_show');
    mainDiv.current.classList.remove('blur_background');
  };

  useEffect(() => {
    const paramString = window.location.href.split('?')[1];
    const queryString = new URLSearchParams(paramString);
    let userIdParam;
    queryString.forEach((value, key) => {
      if (key === 'userId') userIdParam = value;
    });

    if (!userIdParam) window.location.assign('/');
    else setUserId(userIdParam);

    getUserBasicDetailsByMitraAppBackendUserId(userIdParam)
      .then(data => {
        setUserPersonalNumber(data.phoneNumber);
        createMoengageUser(userIdParam, data.name, data.phoneNumber);
      })
      .catch();
  }, []);

  return (
    <div className="referral_component" ref={mainDiv}>
      <div className="image_div">
        <img src={referralImage} alt="referral" />
      </div>
      <div className="content">
        <h2>Earn upto ₹2000 per referral</h2>
        <p style={{ display: 'inline' }} onClick={showKnowMore}>
          Know More
        </p>
      </div>

      {!referralLink && (
        <div className="content position_relative">
          <span
            className="generate_link"
            ref={generateLinkRef}
            style={{ display: 'none' }}
            onClick={generateLink}
          >
            Generate Link
          </span>
          <label htmlFor="invite">Share your Invite</label>
          <input
            type="number"
            placeholder="Enter your friend’s mobile no."
            id="invite"
            value={phoneNumber}
            onChange={onInputChange}
          />
          {errMsg && <p className="err_msg">{errMsg}</p>}
        </div>
      )}
      {referralLink && (
        <div className="content link_generated_div">
          <h4>Link has been generated successfully!</h4>
          <span>Share with your friends to earn more</span>
        </div>
      )}

      <div className="content">
        <a
          href={`https://api.whatsapp.com/send?phone=91${phoneNumber}&text=Hi%2C%20Click%20on%20the%20link%20to%20get%20a%20job%20${referralLink}`}
          data-action="share/whatsapp/share"
          ref={shareWhatsappLink}
          rel="noopener noreferrer"
          target="_blank"
        >
          {' '}
        </a>

        <button
          type="button"
          className="share_on_whatsapp"
          onClick={shareOnWhatsapp}
          disabled={!referralLink}
        >
          <WhatssppLogo />
          <span>Share on Whatsapp</span>
        </button>
      </div>

      <div className="know_more" ref={knowMoreDiv}>
        <div className="know_more_head">
          <div>
            <h3>Here’s how to invite and earn!</h3>
            <span>
              Refer your friends and family to find a new job and you can earn extra money!
            </span>
          </div>
          <img src={referralKnowMore} alt="" />
        </div>
        <ul>
          <li>
            {/* eslint-disable-next-line react/no-unescaped-entities */}
            <p>Enter your friend's contact details</p>
            <span>Earn more by helping your friends and family to get a new job!</span>
          </li>
          <li>
            <p>Invite your friends</p>
            <span>Tap on Share on Whatsapp button to share the unique link generated</span>
          </li>
          <li>
            <p>You get</p>
            <span>
              Referral bonus will be credited for the active riders whose friends have completed
              minimum 10 trips
            </span>
          </li>
        </ul>
        <button type="button" className="btn" onClick={hideKnowMore}>
          Got it
        </button>
      </div>
    </div>
  );
};

export default ReferralComponent;
